import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppLayout } from '../components/AppLayout';
import { LegalHealthCheck } from './LegalHealthCheck';
export function AppReports() {
  const navigate = useNavigate();
  return <AppLayout data-id="element-424">
      <LegalHealthCheck embedded={true} initialViewState="history" onExit={() => navigate('/app')} data-id="element-425" />
    </AppLayout>;
}